import React from "react";
import { Autocomplete, Checkbox, Chip, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

interface Props {
  label?: string;
  name: string;
  size?: "small" | "medium";
  control: any;
  options: Array<{ label: string; value: any }>;
  multiple?: boolean;
  trigger?: () => void;
  required?: boolean;
  disabled?: boolean;
}

function FormAutoCompleteWithSelectAll(props: Props) {
  const {
    name,
    size = "small",
    control,
    label = "",
    options,
    multiple = false,
    trigger,
    required = false,
    disabled = false,
  } = props;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => {
          const isAllSelected =
            field.value?.length === options.length && options.length > 0;
          const handleSelectAll = () => {
            const newValue = isAllSelected ? [] : options;
            field.onChange(newValue);
            if (trigger) {
              trigger();
            }
          };

          return (
            <>
              <Autocomplete
                id={name}
                disabled={disabled}
                size={size}
                multiple
                disablePortal
                disableCloseOnSelect // Keeps the dropdown open when selecting options
                onChange={(_, value) => {
                  field.onChange(value);
                  if (trigger) {
                    trigger();
                  }
                }}
                value={field.value || []}
                options={[{ label: "Select All", value: "selectAll" }, ...options]}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                getOptionLabel={(option) => option.label}
                fullWidth
                renderOption={(props, option, { selected }) => {
                  // Check if it's the "Select All" option
                  if (option.value === "selectAll") {
                    return (
                      <li
                        {...props}
                        onClick={(e) => {
                          e.preventDefault(); // Prevents default behavior
                          handleSelectAll();
                        }}
                      >
                        <Checkbox
                          checked={isAllSelected}
                          style={{ marginRight: 8 }}
                        />
                        Select All
                      </li>
                    );
                  }
                  return (
                    <li {...props}>
                      <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderTags={(value, getTagProps) => {
                  const isAllSelected = value.length === options.length;
                  
                  return (isAllSelected && label == "Client Manager *") ? (
                    <div
                      style={{
                        background: "#e0e0e0",
                        color: "#333",
                        padding: "4px 12px",
                        borderRadius: "16px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      All Selected
                    </div>
                  ) : (
                    value.map((option, index) => (
                      <Chip {...getTagProps({ index })} key={option.id} label={option.label} />
                    ))
                  );
                }}
                renderInput={(params) => (
                  <>
                    <TextField
                      {...params}
                      onBlur={field.onBlur}
                      error={Boolean(error)}
                      label={`${label} ${required ? "*" : ""}`}
                    />
                    {error && (
                      <Typography
                        variant="caption"
                        sx={{ pl: "2px" }}
                        color="rgb(211, 47, 47)"
                      >
                        {error.message || (error as any)?.value?.message}
                      </Typography>
                    )}
                  </>
                )}
              />
            </>
          );
        }}
      />
    </>
  );
}

export default FormAutoCompleteWithSelectAll;
